import { IPlannerVehicleRow } from "../models/ProductionPlanner";

// The shortest term the planner lookup will run — anything less matches most of
// the yard, so it's not worth a round trip.
export const PLANNER_SEARCH_MIN_LENGTH = 2;

// VRMs are stored without spaces, so both sides get squashed before comparing —
// that way "AB12 CDE" finds AB12CDE.
const squash = (value: string): string => value.toLowerCase().replace(/\s+/g, "");

export const plannerSearchTerm = (term: string): string => term.trim().toLowerCase();

// Shared by the awaiting panel and the planner columns so a search highlights and
// filters on exactly the same rules.
export const plannerSearchMatches = (vehicle: IPlannerVehicleRow, term: string): boolean => {
  const needle = plannerSearchTerm(term);
  if (needle.length === 0) return true;

  const haystack = [
    vehicle.vrm,
    vehicle.stockNumber,
    vehicle.combinedMake,
    vehicle.combinedModel,
    vehicle.bodyStyle,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return haystack.includes(needle) || squash(haystack).includes(squash(needle));
};
